import React from 'react';
interface Tab {
  id: string;
  label: string;
}
interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (tabId: string) => void;
}
export const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onChange
}) => {
  return <div className="border-b border-gray-200" data-id="element-138">
      <nav className="flex space-x-8" data-id="element-139">
        {tabs.map(tab => <button key={tab.id} onClick={() => onChange(tab.id)} className={`py-3 px-1 border-b-2 font-medium text-sm ${activeTab === tab.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-140">
            {tab.label}
          </button>)}
      </nav>
    </div>;
};